// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { xglobal } from '@polkadot/x-global';
import { isFunction } from "./is/function.mjs";
import { isString } from "./is/string.mjs";
import { assert } from "./assert.mjs"; // eslint-disable-next-line no-undef

/** @internal */

function expandPath(path) {
  return !path || path.length < 5 ? '<unknown>' : path;
}
/** @internal */


function getEntry(name) {
  var _global = xglobal;

  if (!_global.__polkadotjs) {
    _global.__polkadotjs = {};
  }

  if (!_global.__polkadotjs[name]) {
    _global.__polkadotjs[name] = [];
  }

  return _global.__polkadotjs[name];
}
/** @internal */


function flattenVersions(entry) {
  var all = entry.map(function (version) {
    return isString(version) ? {
      version: version
    } : version;
  });
  var verLength = all.reduce(function (max, _ref) {
    var version = _ref.version;
    return Math.max(max, version.length);
  }, 0);
  return all.map(function (_ref2) {
    var path = _ref2.path,
        version = _ref2.version;
    return "\t".concat(version.padEnd(verLength), "\t").concat(expandPath(path));
  }).join('\n');
}
/** @internal */


function getPath(pathOrFn) {
  if (isFunction(pathOrFn)) {
    try {
      return pathOrFn();
    } catch (error) {
      return undefined;
    }
  }

  return pathOrFn;
}
/**
 * @name detectPackage
 * @summary Checks that a specific package is only imported once
 */


export function detectPackage(_ref3, pathOrFn) {
  var name = _ref3.name,
      version = _ref3.version;
  assert(name.startsWith('@polkadot'), "Invalid package descriptor ".concat(name));
  var entry = getEntry(name);
  entry.push({
    path: getPath(pathOrFn) || '',
    version: version
  });

  if (entry.length !== 1) {
    console.warn("Multiple instances of ".concat(name, " detected, ensure that there is only one package in your dependency tree.\n").concat(flattenVersions(entry)));
  }
}